import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('quantity_ticket')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
